var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page"},[_c('maincontent',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('course',{attrs:{"id":_vm.id}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }